import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  Container,
  DropdownItem,
  Badge,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import CheckIcon from '../../shared/components/custom/CheckIcon';
import Loading from '../../shared/components/custom/Loading';
import useModal from '../../shared/hooks/useModal';
import Api from '../../util/api';
import { formatCurrencyNumber } from '../../util/functions';
import { partial } from '../../util/translation/translation';
import useConfig from '../../util/useConfig';
import { formatDate } from '../../util/date-and-time';

const QuestionaireLeadsPage = ({ questionaireId }) => {
  const config = useConfig();
  const [leads, setLeads] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(true);

  const p = partial('goalSponsor');
  const s = partial('shared');

  const fetchLeads = async () => {
    setLoadingLeads(true);
    try {
      const resLeads =
        await Api.questionaire.leadCompanies.getLeadsForQuestionaire(
          questionaireId
        );
      const userCloudIds = resLeads
        .map((row) => row.answer?.userId)
        .filter((userId) => !!userId);
      const [{ data: foundUsers }] = await Promise.all([
        Api.users.getUsersByCloudIds(userCloudIds),
      ]);
      const mappedLeads = resLeads.map((row) => {
        const foundUser = foundUsers.find(
          (user) => user.userCloudId === row.answer?.userId
        );
        return {
          ...row,
          user: foundUser,
        };
      });
      setLeads(mappedLeads);
      setLoadingLeads(false);
    } catch (err) {
      console.log(err);
      toast.error(err || `${p('auctionRetrievingERROR')}`);
      setLoadingLeads(false);
    }
  };
  useEffect(() => {
    fetchLeads();
  }, []);
  const getTypeColor = (leadStatus) => {
    switch (leadStatus) {
      case 'SUCCESS':
        return 'success';
        break;
      case 'FAILED':
        return 'danger';
        break;
      case 'PENDING':
        return 'warning';
      default:
        return 'default';
    }
  };
  const renderLeads = () => {
    return leads.map((lead, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`lead-${lead.id}`}
      >
        <td>
          <Link to={`/users/edit/${lead.user.userCloudId}`}>
            {lead.user?.firstname} {lead.user?.lastname}
          </Link>
        </td>
        <td>
          <Badge color={getTypeColor(lead.status)}>{lead.status}</Badge>
        </td>
      </tr>
    ));
  };

  return (
    <Container>
      <Loading loading={loadingLeads} />
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              paddingBottom: 5,
              background: '#fff',
              borderRadius: 6,
              boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
            }}
          >
            <Table responsive striped>
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('user')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('status')}</div>
                  </th>
                </tr>
              </thead>
              <tbody>{renderLeads()}</tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionaireLeadsPage;
